/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageSubmissions } from '../../models/page-submissions';

export interface GetAllSubmissionsApiV2SubmissionsOrgAllGet$Params {
  org: string;

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function getAllSubmissionsApiV2SubmissionsOrgAllGet(http: HttpClient, rootUrl: string, params: GetAllSubmissionsApiV2SubmissionsOrgAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSubmissions>> {
  const rb = new RequestBuilder(rootUrl, getAllSubmissionsApiV2SubmissionsOrgAllGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageSubmissions>;
    })
  );
}

getAllSubmissionsApiV2SubmissionsOrgAllGet.PATH = '/api/v2/submissions/{org}/all';
